/**
 * Autoridad única de la modalidad de una configuración Lotowheel.
 * La ausencia conserva el comportamiento histórico: sorteo temporizado.
 */

export const MODALIDAD_LOTOWHEEL = Object.freeze({
    SORTEO: 'sorteo',
    DRAW: 'draw',
    AMBAS: 'ambas',
});
export const MODALIDAD_LOTOWHEEL_POR_DEFECTO = MODALIDAD_LOTOWHEEL.SORTEO;

const MODALIDADES_VALIDAS = new Set(Object.values(MODALIDAD_LOTOWHEEL));

export function normalizarModalidadLotowheel(config) {
    if (!config || typeof config !== 'object' || Array.isArray(config)) {
        throw new TypeError('config Lotowheel inválida: se esperaba un objeto');
    }
    if (!Object.prototype.hasOwnProperty.call(config, 'modalidad')) {
        return MODALIDAD_LOTOWHEEL_POR_DEFECTO;
    }
    if (!MODALIDADES_VALIDAS.has(config.modalidad)) {
        throw new TypeError(
            `modalidad Lotowheel inválida: ${JSON.stringify(config.modalidad)}; ` +
                `valores admitidos: ${[...MODALIDADES_VALIDAS].join(', ')}`
        );
    }
    return config.modalidad;
}

export function modalidadLotowheelHabilitaSorteo(modalidad) {
    return modalidad === MODALIDAD_LOTOWHEEL.SORTEO || modalidad === MODALIDAD_LOTOWHEEL.AMBAS;
}

export function modalidadLotowheelHabilitaDraw(modalidad) {
    return modalidad === MODALIDAD_LOTOWHEEL.DRAW || modalidad === MODALIDAD_LOTOWHEEL.AMBAS;
}

export function exigirCambioModalidadLotowheelSeguro({ modalidadAnterior, modalidadNueva, configActiva }) {
    if (modalidadAnterior !== modalidadNueva && configActiva) {
        throw new Error(
            'No se puede cambiar la modalidad de una config Lotowheel activa; ' +
                'desactívela, espere a que cierre el sorteo en curso y vuelva a editarla'
        );
    }
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        MODALIDAD_LOTOWHEEL,
        MODALIDAD_LOTOWHEEL_POR_DEFECTO,
        normalizarModalidadLotowheel,
        modalidadLotowheelHabilitaSorteo,
        modalidadLotowheelHabilitaDraw,
        exigirCambioModalidadLotowheelSeguro,
    };
}
